import { request } from './apiClient';

// LISTA CENTRAL DE UFs USADA NOS SELECTS DAS TELAS
export const UF_OPTIONS = [
    'AC', 'AL', 'AP', 'AM', 'BA', 'CE', 'DF', 'ES', 'GO',
    'MA', 'MT', 'MS', 'MG', 'PA', 'PB', 'PR', 'PE', 'PI',
    'RJ', 'RN', 'RS', 'RO', 'RR', 'SC', 'SP', 'SE', 'TO'
];

// Valida/normaliza a UF; cai para 'MT' se não estiver na lista.
function normalizeUf(uf) {
    const normalized = (uf || '').trim().toUpperCase();
    return UF_OPTIONS.includes(normalized) ? normalized : 'MT';
}

// Lista base de cidades.
export const getCidade = async () => {
    // AJUSTE BACKEND AQUI: endpoint de listagem base de cidades.
    return await request("/api/cidade");
};

// Cria uma cidade.
export const createCidade = async (cidadeData) => {
    return await request("/api/cidade", {
        method: 'POST',
        body: JSON.stringify(cidadeData)
    });
};

// Atualiza a cidade por id.
export const updateCidade = async (idCidade, cidadeData) => {
    return await request(`/api/cidade/${idCidade}`, {
        method: 'PUT',
        body: JSON.stringify(cidadeData)
    });
};

// Exclui a cidade por id.
export const deleteCidade = async (idCidade) => {
    return await request(`/api/cidade/${idCidade}`, {
        method: 'DELETE'
    });
};

// Atalho: cidades de MT.
export const getCidades = async () => {
    return await request("/api/cidade/uf/mt");
};

// Lista cidades de uma UF (normalizada).
export const getCidadesByUf = async (uf = 'MT') => {
    // AJUSTE BACKEND AQUI: endpoint de cidades por UF.
    const normalizedUf = normalizeUf(uf).toLowerCase();
    return await request(`/api/cidade/uf/${normalizedUf}`);
};

// Busca uma cidade por id.
export const getCidadesById = async (id) => {
    return await request(`/api/cidade/${id}`);
};

// Agrega cidades de todas as UFs em paralelo, removendo duplicadas por id.
export const getAllCidades = async () => {
    // AJUSTE BACKEND AQUI: agrega as UFs consumindo repetidamente o endpoint por UF.
    const results = await Promise.allSettled(
        UF_OPTIONS.map((uf) => getCidadesByUf(uf))
    );

    const flat = results
        .filter((result) => result.status === 'fulfilled' && Array.isArray(result.value))
        .flatMap((result) => result.value);

    const uniqueById = new Map();
    flat.forEach((cidade) => {
        const cidadeId = cidade.idCidade || cidade.id;
        if (!cidadeId) {
            return;
        }
        uniqueById.set(String(cidadeId), cidade);
    });

    return Array.from(uniqueById.values());
};